declare global {
  interface String {
    contains(text: string): boolean;
    toBase64(): string;
    fromBase64(): string;
  }
}

String.prototype.contains = function (this: string, text: string): boolean {
  const str = String(this);
  return !!str && !!text && str.toLowerCase().indexOf(text.toLowerCase()) > -1;
};

String.prototype.toBase64 = function (this: string): string {
  const str = String(this);
  return btoa(str);
};

String.prototype.fromBase64 = function (this: string): string {
  const str = String(this);
  return atob(str);
};

export {};
